/// <amd-module name="SuiteCommerce.Blog.ExtCarousel.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.ExtCarousel.Model", ["require", "exports", "Backbone", "SuiteCommerce.Blog.ExtCarousel.Indicator.Collection", "SuiteCommerce.Blog.ExtCarousel.Indicator.Model"], function (require, exports, Backbone_1, ExtCarousel_Indicator_Collection_1, ExtCarousel_Indicator_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ExtCarouselModel = exports.Transition = void 0;
    var Transition;
    (function (Transition) {
        Transition["fade"] = "fade";
        Transition["slide"] = "slide";
    })(Transition = exports.Transition || (exports.Transition = {}));
    var ExtCarouselModel = /** @class */ (function (_super) {
        __extends(ExtCarouselModel, _super);
        function ExtCarouselModel(options) {
            var _this = _super.call(this, options) || this;
            _this.setupSlideCollectionListener();
            return _this;
        }
        ExtCarouselModel.prototype.setupSlideCollectionListener = function () {
            var _this = this;
            this.slides.on('add reset', function (input) {
                if (input instanceof Backbone_1.Model) {
                    _this.indicators.add(new ExtCarousel_Indicator_Model_1.ExtCarouselIndicatorModel({
                        slide: input,
                        index: _this.slides.indexOf(input),
                    }));
                }
                else {
                    var indicators_1 = [];
                    input.each(function (slide) {
                        indicators_1.push(new ExtCarousel_Indicator_Model_1.ExtCarouselIndicatorModel({
                            slide: slide,
                            index: _this.slides.indexOf(slide),
                        }));
                    });
                    _this.indicators.reset(indicators_1);
                }
            });
        };
        ExtCarouselModel.prototype.defaults = function () {
            return {
                interval: 5000,
                transition: Transition.slide,
                showIndicators: true,
                autoPlay: true,
            };
        };
        Object.defineProperty(ExtCarouselModel.prototype, "carouselTitle", {
            get: function () {
                return this.get('carouselTitle');
            },
            set: function (carouselTitle) {
                this.set('carouselTitle', carouselTitle);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ExtCarouselModel.prototype, "interval", {
            get: function () {
                return this.get('interval');
            },
            set: function (duration) {
                this.set('interval', duration);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ExtCarouselModel.prototype, "transition", {
            get: function () {
                return this.get('transition');
            },
            set: function (transition) {
                this.set('transition', transition);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ExtCarouselModel.prototype, "showIndicators", {
            get: function () {
                return this.get('showIndicators');
            },
            set: function (showIndicators) {
                this.set('showIndicators', showIndicators);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ExtCarouselModel.prototype, "slides", {
            get: function () {
                return this.get('slides');
            },
            set: function (slides) {
                this.set('slides', slides);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ExtCarouselModel.prototype, "autoPlay", {
            get: function () {
                return this.get('autoPlay');
            },
            set: function (autoPlay) {
                this.set('autoPlay', autoPlay);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ExtCarouselModel.prototype, "indicators", {
            get: function () {
                if (!this.get('indicators'))
                    this.set('indicators', new ExtCarousel_Indicator_Collection_1.ExtCarouselIndicatorCollection());
                return this.get('indicators');
            },
            enumerable: false,
            configurable: true
        });
        return ExtCarouselModel;
    }(Backbone_1.Model));
    exports.ExtCarouselModel = ExtCarouselModel;
});
